import { isSuit, isTrait } from "../types";

export function getSectionColors(type) {
	switch (type) {
		case 'play':
			return {
				background: '#FEFEFE',
				label: '#010101',
				stripOverride: 'lightgrey'
			};
		case 'table':
			return {
				background: '#657dce',
				label: 'white',
				stripOverride: '#3057a1',
				textOverride: 'white'
			};
		case 'resupply':
			return {
				background: '#CCD8CC',
				label: '#1f6e24',
				stripOverride: '#41AD49'
			};
		case 'special':
			return {
				background: '#C3B4D4',
				label: 'purple'
			};
		case 'endgame':
			return {
				background: '#E4ABA1',
				label: '#C53526'
			};
		case 'cost':
			return {
				background: '#666',
				label: 'white',
				stripOverride: 'black',
				textOverride: 'white'
			};
		case 'goal':
			return {
				background: '#FEFEFE',
				label: '#010101'
			};
		case 'accept':
			return {
				background: '#FEFEFE',
				label: '#010101'
			};
		case 'reward':
			return {
				background: '#CCD8CC',
				label: '#298a31'
			};
	}
}

export function replaceTextShortcuts(text) {
	let result = text;
	result = text
		.replaceAll(
			' OR ',
			' <span style="font-family:\'trade-gothic-next\';font-weight:600;"><i>OR</i></span> '
		)
		.replaceAll(' may ', ' <i>may</i> ')
		.replaceAll('Play:', '<span style="font-family:\'Antonio\';">PLAY:</span>')
		.replaceAll('ATTACK', '<span style="font-family:\'Antonio\';color:red;">ATTACK</span>')
		.replaceAll(new RegExp(/@(.+?)\/@/g), '<span style="color:red;font-weight:600;">$1</span>')
		.replaceAll(
			new RegExp(/\$(.+?)\/\$/g),
			'<span style="color:darkblue;font-weight:600;">$1</span>'
		)
		.replaceAll(new RegExp(/\^(.+?)\^/g), '<b>$1</b>')
		.replaceAll(new RegExp(/\*([\w()'-. ]+?)\*/g), '<i>$1</i>');
	return result;
}

export function parseRestriction(restriction){
	try {
		const re_specialty = new RegExp(/(res|inf|mil|col|tre)(\d+)/g).exec(restriction);
		if (re_specialty)
			return {
				type: 'specialty',
				specialty: `${re_specialty[1]}-restriction`,
				threshold: parseInt(re_specialty[2])
			};

		const re_captain = new RegExp(/cpt-(.+)$/g).exec(restriction);
		if (re_captain && (isTrait(re_captain[1]) || re_captain[1] === 'qsuit'))
			return {
				type: 'captain',
				icon: re_captain[1]
			};

		const re_suit = new RegExp(/^(.+):(\d+)$/g).exec(restriction);
		if (re_suit && isSuit(re_suit[1]))
			return {
				type: 'suit',
				suit: 'encounter',
				threshold: parseInt(re_suit[2])
			};
	} catch {
		return undefined;
	}
}